import webpWithPngFallback from '../utils/webp-with-png-fallback';
import useDoesSupportWebp from './use-does-support-webp';

export default function useWebpWithPngFallback(imageUrl: string): string {
  const doesSupportWebp = useDoesSupportWebp();

  return webpWithPngFallback(imageUrl, doesSupportWebp);
}
